import {
  EditorialSidePanelContextProvider as BaseEditorialSidePanelContextProvider,
  EditorialSidePanelContextProviderProps,
} from '@monofront/business/contexts';
import { SidePanelRouterEventListener } from '@context/SidePanelRouterEventListener';

export const EditorialSidePanelContextProvider: React.FC<
  EditorialSidePanelContextProviderProps
> = ({ children, ...props }) => (
  <BaseEditorialSidePanelContextProvider {...props}>
    <SidePanelRouterEventListener />
    {children}
  </BaseEditorialSidePanelContextProvider>
);
